// React imports
import React from 'react';
import classnames from 'classnames';
import { commonEnums } from '@codametrix/ui-common';
import { CmAlertDialog } from '@codametrix/ui-components';
import './styles/index.scss';
const { HoldReasonType } = commonEnums;

/**
 * State for the Case Hold component
 */
type CaseHoldState = {
  holdReason: string;
  comment: string;
};

export enum HoldReasonLabel {
  HOLD = 'Hold',
  HOLD_FOR_DOCUMENTATION_QUERY = 'Hold for documentation query',
  HOLD_FOR_MANAGER_REVIEW = 'Hold for manager review',
  OFF_HOLD = 'Off hold'
}

class CaseHold extends React.Component<
  Accelerate.CaseHoldProps,
  CaseHoldState
> {
  static displayName = 'CaseHold';
  /**
   * Constructor method for class CaseHold
   * @param {Accelerate.CaseHoldProps} props - Props object passed to CaseHold component
   */
  private cancelButtonRef = React.createRef<HTMLButtonElement>();

  constructor(props: Accelerate.CaseHoldProps) {
    super(props);
    this.state = {
      comment: '',
      holdReason: HoldReasonType.HOLD
    };
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.holdCase = this.holdCase.bind(this);
    this.cancelHold = this.cancelHold.bind(this);
  }

  /**
   * Method to handle the change event for radio button options
   * @param {Object} event - Event object
   */
  handleOptionChange(event) {
    this.setState({ holdReason: event.target.id });
  }

  /**
   * Method to handle the change event for text area element
   * @param {Object} event - Event object
   */
  handleCommentChange(event) {
    this.setState({ comment: event.target.value });
  }

  /**
   * Method to hold the case
   */
  holdCase() {
    this.props.onHold(this.state.holdReason, this.state.comment);
  }

  /**
   * Method to cancel holding the case
   */
  cancelHold() {
    this.props.onCancel();
  }

  render() {
    return (
      <CmAlertDialog
        isOpen={true}
        onClose={this.cancelHold}
        title={this.props.title}
        leastDestructiveRef={this.cancelButtonRef}
        footer={
          <>
            <button
              ref={this.cancelButtonRef}
              type="button"
              onClick={this.cancelHold}
              className="chakra-secondary-button">
              Cancel
            </button>
            <button
              type="button"
              onClick={this.holdCase}
              className={classnames('chakra-primary-button')}>
              Hold
            </button>
          </>
        }>
        <form className="case-hold" onSubmit={e => e.preventDefault()}>
          <p className="case-hold-subtitle">
            The case will be put on hold for 3 days.
          </p>

          <div className="case-hold-group">
            <div className="case-hold-radio-group">
              <input
                type="radio"
                name="holdReason"
                id={HoldReasonType.HOLD}
                className="case-hold-radio-input"
                onChange={this.handleOptionChange}
                checked={this.state.holdReason === HoldReasonType.HOLD}
              />
              <label
                className="case-hold-label-radio case-hold-radio-label"
                htmlFor={HoldReasonType.HOLD}>
                <span className="case-hold-radio-button"></span>
                {HoldReasonLabel.HOLD}
              </label>
            </div>

            <div className="case-hold-radio-group">
              <input
                type="radio"
                name="holdReason"
                id={HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY}
                className="case-hold-radio-input"
                onChange={this.handleOptionChange}
                checked={
                  this.state.holdReason ===
                  HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY
                }
              />
              <label
                className="case-hold-label-radio case-hold-radio-label"
                htmlFor={HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY}>
                <span className="case-hold-radio-button"></span>
                {HoldReasonLabel.HOLD_FOR_DOCUMENTATION_QUERY}
              </label>
            </div>

            <div className="case-hold-radio-group">
              <input
                type="radio"
                name="holdReason"
                id={HoldReasonType.HOLD_FOR_MANAGER_REVIEW}
                className="case-hold-radio-input"
                onChange={this.handleOptionChange}
                checked={
                  this.state.holdReason ===
                  HoldReasonType.HOLD_FOR_MANAGER_REVIEW
                }
              />
              <label
                className="case-hold-label-radio case-hold-radio-label"
                htmlFor={HoldReasonType.HOLD_FOR_MANAGER_REVIEW}>
                <span className="case-hold-radio-button"></span>
                {HoldReasonLabel.HOLD_FOR_MANAGER_REVIEW}
              </label>
            </div>
          </div>

          <textarea
            className="case-hold-comment cmx-form-input input"
            placeholder="Enter comments (optional)"
            maxLength={1024}
            onChange={this.handleCommentChange}
            rows={4}></textarea>
        </form>
      </CmAlertDialog>
    );
  }
}

export { CaseHold };
